import { render, staticRenderFns } from "./contacts-info-dialog.vue?vue&type=template&id=f5e30b44&scoped=true"
import script from "./contacts-info-dialog.vue?vue&type=script&lang=js"
export * from "./contacts-info-dialog.vue?vue&type=script&lang=js"
import style0 from "./contacts-info-dialog.vue?vue&type=style&index=0&id=f5e30b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e30b44",
  null
  
)

export default component.exports